const initPersonasMayores = function () {
    const getAutoplaySrc = function (videoSrc) {
        try {
            const url = new URL(videoSrc, window.location.href);
            const host = url.hostname.toLowerCase();

            if (host.indexOf('brightcove.net') !== -1) {
                url.searchParams.set('autoplay', 'muted');
                url.searchParams.set('muted', 'true');
                url.searchParams.set('playsinline', 'true');
            } else if (host.indexOf('youtube') !== -1 || host.indexOf('youtu.be') !== -1) {
                url.searchParams.set('autoplay', '1');
                url.searchParams.set('mute', '1');
                url.searchParams.set('playsinline', '1');
            } else {
                url.searchParams.set('autoplay', '1');
                url.searchParams.set('muted', '1');
                url.searchParams.set('playsinline', '1');
            }

            return url.toString();
        } catch (error) {
            return videoSrc;
        }
    };

    document.querySelectorAll('[data-pm-youtube-player]').forEach(function (player) {
        const playButton = player.querySelector('[data-pm-youtube-play]');
        const videoSrc = player.getAttribute('data-pm-youtube-src');
        const videoTitle = player.getAttribute('data-pm-youtube-title') || 'Video de YouTube';
        const shouldAutoplay = player.hasAttribute('data-pm-youtube-autoplay');

        if (!playButton || !videoSrc) {
            return;
        }

        const loadVideo = function () {
            if (player.querySelector('iframe')) {
                return;
            }

            const iframe = document.createElement('iframe');
            iframe.src = shouldAutoplay ? getAutoplaySrc(videoSrc) : videoSrc;
            iframe.title = videoTitle;
            iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
            iframe.allowFullscreen = true;
            iframe.loading = 'eager';
            iframe.referrerPolicy = 'strict-origin-when-cross-origin';

            player.classList.add('is-playing');
            player.appendChild(iframe);
        };

        playButton.addEventListener('click', loadVideo);

        if (shouldAutoplay) {
            loadVideo();
        }
    });

    document.querySelectorAll('[data-pm-video-player]').forEach(function (player) {
        const video = player.querySelector('video');
        const playButton = player.querySelector('[data-pm-video-play]');

        if (!video || !playButton) {
            return;
        }

        playButton.addEventListener('click', function () {
            video.controls = true;
            const playback = video.play();

            if (playback !== undefined) {
                playback.catch(function () {
                    video.controls = false;
                    player.classList.remove('is-playing');
                });
            }
        });

        video.addEventListener('play', function () {
            player.classList.add('is-playing');
        });

        video.addEventListener('pause', function () {
            player.classList.remove('is-playing');
        });

        video.addEventListener('ended', function () {
            video.controls = false;
            player.classList.remove('is-playing');
        });
    });

    document.querySelectorAll('[data-pm-faq]').forEach(function (faq) {
        const toggleButton = faq.querySelector('[data-pm-faq-toggle]');
        const items = faq.querySelectorAll('details');

        if (!toggleButton || !items.length) {
            return;
        }

        const setExpandedState = function (item, shouldOpen) {
            const content = item.querySelector('div');

            if (!content || item.dataset.pmAnimating === 'true' || item.open === shouldOpen) {
                return;
            }

            item.dataset.pmAnimating = 'true';
            content.style.overflow = 'hidden';

            if (shouldOpen) {
                item.open = true;
                content.style.height = '0px';

                requestAnimationFrame(function () {
                    content.style.height = content.scrollHeight + 'px';
                });
            } else {
                content.style.height = content.scrollHeight + 'px';

                requestAnimationFrame(function () {
                    content.style.height = '0px';
                });
            }

            const finishTransition = function (event) {
                if (event.target !== content || event.propertyName !== 'height') {
                    return;
                }

                content.removeEventListener('transitionend', finishTransition);

                if (!shouldOpen) {
                    item.open = false;
                }

                content.style.height = '';
                content.style.overflow = '';
                item.dataset.pmAnimating = 'false';
                syncLabel();
            };

            content.addEventListener('transitionend', finishTransition);
        };

        const syncLabel = function () {
            const allOpen = Array.from(items).every(function (item) {
                return item.open;
            });

            faq.classList.toggle('is-collapsed', !allOpen);
            toggleButton.textContent = allOpen ? 'Mostrar menos' : 'Expandir todo';
        };

        toggleButton.addEventListener('click', function () {
            const allOpen = Array.from(items).every(function (item) {
                return item.open;
            });

            items.forEach(function (item) {
                setExpandedState(item, !allOpen);
            });
        });

        items.forEach(function (item) {
            const summary = item.querySelector('summary');

            if (!summary) {
                return;
            }

            const content = item.querySelector('div');

            if (content) {
                content.style.height = item.open ? '' : '0px';
                content.style.overflow = 'hidden';
            }

            summary.addEventListener('click', function (event) {
                event.preventDefault();
                setExpandedState(item, !item.open);
            });
        });

        syncLabel();
    });

    document.querySelectorAll('[data-pm-carousel]').forEach(function (carousel) {
        const track = carousel.querySelector('[data-pm-carousel-track]');
        const viewport = carousel.querySelector('.pm-creativity-carousel__viewport');
        const dots = Array.from(carousel.querySelectorAll('[data-pm-carousel-dot]'));
        const slides = Array.from(track ? track.children : []);
        let activeIndex = 0;

        if (!track || !viewport || !dots.length || slides.length < 2) {
            return;
        }

        const setActiveDot = function (activeIndex) {
            dots.forEach(function (dot, index) {
                const isActive = index === activeIndex;
                dot.classList.toggle('is-active', isActive);
                dot.setAttribute('aria-pressed', isActive ? 'true' : 'false');
            });
        };

        const getOffsetForIndex = function (index) {
            const firstSlide = slides[0];
            const slideStyles = window.getComputedStyle(track);
            const gap = parseFloat(slideStyles.columnGap || slideStyles.gap || '0');
            const maxOffset = Math.max(track.scrollWidth - viewport.clientWidth, 0);
            const maxIndex = Math.max(dots.length - 1, 1);
            const safeIndex = Math.max(0, Math.min(index, dots.length - 1));
            const baseOffset = (firstSlide.offsetWidth + gap) * safeIndex;
            const distributedOffset = maxOffset * (safeIndex / maxIndex);
            return Math.min(Math.max(baseOffset, distributedOffset), maxOffset);
        };

        const updateCarousel = function (index) {
            activeIndex = Math.max(0, Math.min(index, dots.length - 1));
            const offset = getOffsetForIndex(activeIndex);
            viewport.scrollTo({
                left: offset,
                behavior: 'smooth'
            });
            setActiveDot(activeIndex);
        };

        const syncActiveDotFromScroll = function () {
            const maxOffset = Math.max(track.scrollWidth - viewport.clientWidth, 0);

            if (maxOffset <= 0) {
                setActiveDot(0);
                activeIndex = 0;
                return;
            }

            const progress = viewport.scrollLeft / maxOffset;
            const index = Math.round(progress * Math.max(dots.length - 1, 1));
            activeIndex = Math.max(0, Math.min(index, dots.length - 1));
            setActiveDot(activeIndex);
        };

        dots.forEach(function (dot, index) {
            dot.addEventListener('click', function () {
                updateCarousel(index);
            });
        });

        window.addEventListener('resize', function () {
            updateCarousel(activeIndex);
        });

        viewport.addEventListener('scroll', function () {
            syncActiveDotFromScroll();
        }, { passive: true });

        updateCarousel(0);
    });
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPersonasMayores);
} else {
    initPersonasMayores();
}
